import Vue from 'vue'

// 深度拷贝
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

// 数组分类
export function groupBy(array, f) {
  let groups = {};
  array.forEach(function (o) {
    let group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

export default {
  install(Vue, options) {
    Vue.prototype.clone = deepClone
    Vue.prototype.groupBy = groupBy
  }
}

export function formatTime(datetime, format) {
  if (!datetime) {
    return '-'
  }
  const time = new Date(datetime)
  if (!time || time.getTime() <= 0) {
    return '-'
  }
  format = format || 'YYYY-MM-DD'
  return Vue.time(time).format(format)
}

export function taskStyle(status) {
  let style = {
    title: '',
    statusTagClass: '',
    taskClass: ''
  }
  switch (status) {
    case 0:
      style.title = '待分配'
      style.statusTagClass = 'label-default'
      style.taskClass = ''
      break
    case 1:
      style.title = '未开始'
      style.statusTagClass = 'label-primary'
      style.taskClass = 'task-primary'
      break
    case 2:
      style.title = '进行中'
      style.statusTagClass = 'label-info'
      style.taskClass = 'task-info'
      break
    case 3:
      style.title = '待检验'
      style.statusTagClass = 'label-warning'
      style.taskClass = 'task-warning'
      break
    case 4:
      style.title = '检验不合格'
      style.statusTagClass = 'label-danger'
      style.taskClass = 'task-danger'
      break
    case 100:
      style.title = '已完成'
      style.statusTagClass = 'label-success'
      style.taskClass = 'task-success'
      break
    default:
  }
  return style
}